import { FC, HTMLAttributes } from "react"
import clsx from "clsx"

export const BasicCard: FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...props
}) => {
  return (
    <div {...props} className={clsx("bg-white rounded-[10px] p-[30px]", className)}>
      {children}
    </div>
  )
}
